import { Language } from './base';

const pdash = () => import('../translations/pdash/fr-CA.json');
const webActivities = () => import('../translations/web-activities/fr-CA.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/fr-CA.json');

export default new Language({
    code: 'fr-CA',
    locale: 'fr',
    localName: 'Français',
    englishName: 'French',
    territory: 'CA',
    timezones: ['America/Montreal', 'Europe/Paris'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
